module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAwAAAAAwBAMAAABUPQCNAAAAD1BMVEUAAABSiv8yMjJRh/9Rhv8kILTYAAAABHRSTlMAMjPuJ6X9KwAAAMhJREFUeNrt2NsJhDAUQEG3A8EOtoMFOzD912QLK34cLszpIAmT17ZJL/rs5iDt+JmDFMB5IZACWAuBFMBaCLQAEIgBIFADQCAGgEANAIEYAAI1AARiAAjUABCIASBQA0AgBoBADQCBGAACNQAEYgAI1AAQiAGMJfAd0tMFGDOuiQvwzxY0clwOYbmGeojJV4TPOD0lAEBLAICYAAAtAQBiAgC0BACICQDQEgAgJgBASwCAmAAALQEAYgIAtAQAiAkAEBMAQK+6ASWy38v0ZvxFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/title_underline@2x.png
// module id = QshK
// module chunks = 0